import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { replaceMedia } from '../../utils/media';
import { mediaBreakpointDown } from '../../utils/styling';
// import { smbCategories } from '../../utils/smbCategories';
// import CTAForm from '../CTAForm';

const Section = styled.section`
	color: #617792;
	width: 100%;
	position: relative;
	margin: 0px 0px 27.2px;
	font-weight: 400;
	font-size: 16px;
	line-height: 1.85em;
	letter-spacing: -0.017em;
	color: #617792;
	margin-bottom: 0;

	iframe {
		width: 100%;
	}
	p {
		color: #617792;
		font-weight: 500;
		font-size: 16px !important;
		* {
			font-size: 16px !important;
		}
		span {
			font-weight: 500 !important;
		}
	}
	li {
		font-size: 16px;
		font-weight: 600 !important;
		span {
			font-weight: 600 !important;
		}
		a, .link-button {
			&:hover {
				color: #B2298C !important;
			}
			span {
				font-weight: 600 !important;
			}
		}
	}
	> h1 {
		font-size: 32px;
		font-weight: 700 !important;
		line-height: 34px;
		color: #232e69;
		span {
			font-weight: 700 !important;
		}
		${mediaBreakpointDown('sm')} {
			font-size: 29px;
			margin: 20px 0px 20px;
			line-height: 33px;
		}
	}

	h2 {
		font-size: 25px;
		color: #232e69;
		line-height: 26px;

		${mediaBreakpointDown('sm')} {
			margin: 20px 0px 20px;
		}
		span {
			font-size: 25px;
			font-weight: 700 !important;
			color: #232e69;
			margin-bottom: 20px;
			${mediaBreakpointDown('sm')} {
				font-size: 25px;
				margin-bottom: 15px;
				margin-top: 20px;
			}
		}
	}

	h3 {
		color: #232e69;
		font-family: Poppins, Helvetica, Arial, sans-serif;
		font-weight: 700 !important;
		font-size: 16px;
		span {
			font-weight: 700 !important;
		}
	}

	p {
		margin: 0px 0px 0px;
		font-weight: 400;
		font-size: 14px;
		line-height: 1.85em;
		letter-spacing: -0.017em;
		color: #617792;
		margin-bottom: 1.5em;
	}

	li {
		margin: 0px 0px 24px;
	}
	a {
		color: #e01efee8;
		text-decoration: underline;
		transition: all 0.3s ease-in-out 0s;
	}

	table {
		max-width: 100%;
		background-color: #f0f5f8;
		font-weight: 400;
		color: #617792e9;
		font-size: 14px;
		border-collapse: collapse;
		overflow-x: auto;
		display: inline-block;
		width: fit-content;
		border-spacing: 0;
		text-indent: initial;
		margin-bottom: 20px;
		tr:nth-child(even) {
			background: white;
		}
		td {
			padding: 8px 15px;
			vertical-align: top;
			width: auto;
			border: 1px solid #e5e5e5;
			span {
				font-weight: 600 !important;
				padding: 5px;
			}
		}
		th {
			border: 1px solid #e5e5e5;
			padding: 8px 15px;
			vertical-align: top;
			span {
				font-weight: 600 !important;
				padding: 5px;
			}
		}

		ul, ol {
			white-space: normal;
			margin-top: 0px;
		}
		li {
			margin-bottom: 20px;
		}
	}

	img {
		object-fit: contain !important;
		height: auto;
		width: 90%;
		border-radius: 15px;
		margin: 25px 0;
		${mediaBreakpointDown('sm')} {
			margin: 20px 0;
		}
	}

	picture {
		object-fit: contain !important;
	}

	> span {
		font-size: 16px !important;
	}

	> strong {
		font-size: 16px !important;
	}

	ul, ol {
		white-space: normal;
		margin-top: 20px;
	}

	ol li span img {
		margin: 25px 0 0 0;
	}

	div > img {
		border-radius: 0;
	}
`;

const PostBody = React.memo(({ post }) => {
	const ref = useRef();
	const [init, setInit] = useState(true);

	useEffect(() => {
		window.addEventListener('scroll', () => {
			setInit(false);
			window.removeEventListener('scroll', () => { });
		});

		return () => {
			window.removeEventListener('scroll', () => { });
		};
	}, []);

	// conditional is for smb ctas mainly
	// const slug = smbCategories[post?.categories?.nodes[0]?.name] ? "business" : post.slug;
	const slug = post.slug;

	return (
		<Section itemProp="articleBody" className='post-body-section' ref={ref}>
			{parse(post.content, {
				replace: (val) => replaceMedia(val, post.title, post.category, slug, init, post.author),
			})}
		</Section>
	);
});

export default PostBody;
